import React from 'react';

import CommonFeed from '../CommonFeed/CommonFeed';

const CommonFeedWrapper = ({ data }) => {
  const getFeedPageData = (data) => {
    const path = data.page.uri;
    if (path.includes('stories')) {
      return {
        page: data.page,
        data: data.story,
        category: data.category,
        parentTitle: 'Homeowner Stories',
        parentSlug: 'stories',
      };
    } else if (path.includes('homeowner-resources')) {
      return {
        page: data.page,
        data: data.resource,
        category: data.category,
        parentTitle: 'Homeowner Resources',
        parentSlug: 'homeowner-resources',
      };
    }
  };

  return (
    <div className="CommonFeedWrapper">
      <CommonFeed {...getFeedPageData(data)} />
    </div>
  );
};

export default CommonFeedWrapper;
